import { FC } from 'react';
import { AnalyticsLineChart } from 'shared/ui/Analytics/AnalyticsLineChart';
import { LineChartData } from 'shared/ui/Analytics/types';
import { getRenamedLineChartData } from '../../../lib/getRenamedLineChartData';

interface ObjectOpenedSelectionLotChartProps {
  pointsData: LineChartData[];
  minWidth: number;
}

const chartLines = [
  { key: 'line', label: 'Открытие лотов в подборках', color: '#20B2AA' },
];

export const ObjectOpenedSelectionLotChart: FC<
  ObjectOpenedSelectionLotChartProps
> = ({ pointsData, minWidth }) => {
  const renamedPointsData = getRenamedLineChartData(pointsData, chartLines);

  return (
    <AnalyticsLineChart
      data={renamedPointsData}
      lineLabels={chartLines.map((l) => l.label)}
      lineColors={chartLines.map((l) => l.color)}
      height={200}
      minWidth={minWidth}
    />
  );
};
